/**
 * Client-side "Surprise me" Code Name suggester.
 *
 * Mirrors the shape enforced by /app/backend/utils/code_name.py — two
 * ALL-CAPS words separated by a single space, total length 4–16 chars.
 * Kept as a small curated set so first-time members can taste a valid
 * Code Name without any server round-trip.
 *
 * The backend availability endpoint still gates the actual save, so a
 * "taken" suggestion is harmless — the member will simply see the
 * usual "try one of these" chips and pick another.
 */

const COLOURS = [
  'SKY', 'AMBER', 'JADE', 'ONYX', 'IVORY', 'CORAL', 'SLATE', 'ROYAL',
  'PEARL', 'RUBY', 'JET', 'FROST', 'DUSK', 'STEEL', 'COBALT', 'ROSE',
];

const NOUNS = [
  'FOX', 'HAWK', 'OWL', 'WOLF', 'LION', 'TIGER', 'EAGLE', 'RAVEN',
  'FALCON', 'HERON', 'LYNX', 'ORCA', 'BEAR', 'STAG', 'DOE', 'CRANE',
  'SWAN', 'DOVE', 'MOON', 'STAR', 'SUN', 'DAWN', 'MIST', 'PEAK',
  'RIVER', 'LAKE', 'REEF', 'SHORE', 'GROVE', 'BEACON',
];

const MIN_LEN = 4;
const MAX_LEN = 16;

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export function randomCodeName() {
  // Try up to 25 times; in practice succeeds first pick for most pairs.
  for (let i = 0; i < 25; i += 1) {
    const candidate = `${pick(COLOURS)} ${pick(NOUNS)}`;
    if (candidate.length >= MIN_LEN && candidate.length <= MAX_LEN) {
      return candidate;
    }
  }
  return 'JADE FOX'; // safe fallback, always within length bounds.
}
